const demoData = (range) => {
  const demo = {
    data: [
      {
        x: ' . ',
        y: range,
        entryType: ''
      },
      {
        x: ' .. ',
        y: range,
        entryType: ''
      }
    ],
    id: 'CHARTDATA'
  };

  return demo;
};
export { demoData };
